<template>
  <div class="group unCategorized">
    <div class="item">
      <!-- options -->
      <div class="option">
        <!-- option :: checkbox -->
        <span v-if="option.checkbox" class="checkbox">
          <input type="checkbox" name="checkCategory" :id="`check_${item.id}`" :value="item.id" v-model="checked">
          <label :for="`check_${item.id}`"><span class="blind">check</span></label>
        </span>
        <!-- //option :: checkbox -->
        <!-- option :: radio -->
        <span v-if="option.selected" class="icoSelect checkbox radio">
          <input type="radio" name="selectCategory" :id="`select_${item.id}`" :value="item.id" v-model="state.selected" @change="selectedItem(item)">
          <label :for="`select_${item.id}`"><span class="blind">check</span></label>
        </span>
        <!--// option :: radio -->
      </div>
      <!-- //options -->
      <!-- label -->
      <div class="listLabel">
        <div class="input">
          uncategorized
        </div>
      </div>
      <!-- label -->
    </div>
  </div>
</template>

<script>
import UNIQUE from '@/common/unique.js'

export default {
  name: 'UnCategorized',
  props: [
    'item',
    'option',
    'state',
    'setCheckItem'
  ],
  computed: {
    checkCategory () {
      return this.item
    },
    checkedAll () {
      return this.state.checked
    },
    isSelected () {
      return this.state.selected === this.item.id
    },
    checked: {
      get () {
        if (!this.option.checkAll) {
          return this.setCheckItem.includes(this.item.id)
        } else {
          return this.state.checked
        }
      },
      set (isChecked) {
        // console.log(isChecked)
        const data = {id: this.item.id, isChecked: isChecked}
        this.$store.commit('category/setChecked', data)
      }
    }
  },
  methods: {
    selectedItem (item) {
      this.$emit('selected', item)
    }
  }
}
</script>
